import { NavLink } from "react-router-dom";
import {
  getPageDescription,
  getPageName,
  getUiInterface,
} from "../../locales/translationUtils";

/**
 * Represents the properties required to render a card component.
 * Each card displays an icon, a title, a description, and a link to a specific route.
 */
interface CardProps {
  /**
   * The name of the Bootstrap icon class to display on the card.
   * Example: "bi-box", "bi-truck".
   */
  iconName: string;

  /**
   * A key used to fetch the card's title and description from the translation utilities.
   * This key should correspond to entries in the localization files.
   */
  cardName: string;

  /**
   * The route to navigate to when the card is clicked.
   * This should match the `to` property in the React Router's `NavLink`.
   * Example: "/some-route", "home".
   */
  route: string;

  //TO-DO: Ao finalizar os módulos, remover prop abaixo, remover do parametro da linha 36 e 39
  className?: string;
}

const Card: React.FC<CardProps> = ({ iconName, cardName, route, className  }) => {
  return (
    <div className="col">
      <div className={`card h-100 text-center ${className ?? ""}`}>
        <div className="card-body">
          <i className={`bi bi-${iconName} display-1 text-primary`}></i>
          <h5 className="card-title mt-3">{getPageName(cardName)}</h5>
          <p className="card-text">{getPageDescription(cardName)}</p>
          <NavLink to={route} className="btn btn-primary">
            {getUiInterface("access")}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Card;
